import { Checkbox } from 'antd';

export const CheckList = ({ label, checked, onChange }) => (
	<Checkbox 
        checked={checked} 
        onChange={onChange}>
        <label style={{ fontFamily: "poppins medium", fontSize: "12px" }}>{label ? label?.toUpperCase() : ""}</label>
    </Checkbox>
)